import Header from './Header';
import { Outlet, useLocation } from 'react-router-dom';
import Footer from './Footer';
import { Box, Stack } from "@mui/material";
import CustomSnackbar from '../components/CustomSnackbar';
import { useState, useEffect } from 'react';
import { useTheme } from '@emotion/react';
import { useTenant } from '../contexts/TenantContext';
import Loading from '../components/Loading';
import ScrollToTopButton from '../components/ScrollToTopButton';
import ScrollToTopOnNavigate from '../components/ScrollToTopOnNavigate';
import { Routes } from '../routes/RouteConstants';

const SHOW_INFO_NOTICE = false;

export default function RootLayout() {
  const [isInfoSnackbarOpen, setIsInfoSnackbarOpen] = useState(false);
  const [headerKey, setHeaderKey] = useState(0);
  const { tenant, loading, error } = useTenant();
  const theme = useTheme();
  const location = useLocation();

  const forceHeaderReRender = () => {
    setHeaderKey((prevKey) => prevKey + 1);
  };

  // No warning about in-app browsers here: only Google sign-in fails in them, and the login page
  // says so in the Google button's place (docs/EMAIL_AUTH.md A1).
  useEffect(() => {
    if (SHOW_INFO_NOTICE && location.pathname !== Routes.DASHBOARD) {
      setIsInfoSnackbarOpen(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (loading) {
    return (
      <Box minHeight="100vh" display="flex" flexDirection="column" justifyContent="center" alignItems="center">
        <Loading size={124}/>
      </Box>
    ) 
  }

  if (error) {
    return (
      <Box minHeight="100vh" display="flex" flexDirection="column" justifyContent="center" alignItems="center">
        {error}
      </Box>
    ) 
  }

  // Everything under /dashboard has the admin's own top bar and menu (AdminLayout), so the guest
  // header, footer and scroll button stay off it.
  const isAdminArea = location.pathname === Routes.DASHBOARD || location.pathname.startsWith(`${Routes.DASHBOARD}/`);

  if (tenant) {
    return (
      <Stack sx={{ background: theme.background }}>
        <ScrollToTopOnNavigate />
        <CustomSnackbar
          open={isInfoSnackbarOpen}
          setOpen={setIsInfoSnackbarOpen}
          message="Kedves Vendégeim!
          Április 30-tól (csütörtök) május 7-ig (csütörtök) szabadságon leszek."
          severity="info"
        />
        {!isAdminArea && <Header key={headerKey} onAuthChange={forceHeaderReRender} />}
        <Box minHeight="100vh">
          <Outlet  sx={{ minHeight: "100vh" }} context={{ forceHeaderReRender }}/>
        </Box>
        {!isAdminArea && <Footer />}
        {!isAdminArea && <ScrollToTopButton />}
      </Stack>
    )
  }
  
}
